import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService, UserService} from "../services";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FormControl, FormGroup} from "@angular/forms";
import {first} from "rxjs/operators";
import {MatDatepickerInputEvent} from "@angular/material/datepicker";
import {ServiceUseReportService} from "./service/serviceUseReport.service";
import {ServiceUseReportItems} from "./models/serviceUseReportItems";
import {ServiceUseReport} from "./models/serviceUseReport";
import {User} from "../models";
import {Items} from "../models/items";

@Component({
    templateUrl: './servicesUse.component.html',
    styleUrls: ['./servicesUse.component.scss']
})

export class ServicesUseComponent implements OnDestroy, OnInit {
    dateRange: FormGroup;
    fastDate: string = 'lastWeek';
    reportData: ServiceUseReport[];
    summary: number = 0;
    locale: string = 'pl';
    workers: User[] = [];

    constructor(
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private serviceUseReportService: ServiceUseReportService,
        private userService: UserService,
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Reports');
        componentTitleService.addPart('Raport wykonanych usług');

        let today = new Date();

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
            worker: new FormControl()
        });
    }

    ngOnInit() {
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-7)));
        let end = this.convertDateToString(new Date());

        this.updateReportData(start, end);

        this.userService.getAllWorkers().subscribe((items: Items) => {
            this.workers = items.items;
        });
    }

    ngOnDestroy(): void {

    }

    updateReportData(createdAt: string, createdAtTo: string): void {
        let data = this.dateRange.getRawValue();
        let worker = data.worker;

        this.reportData = [];
        this.serviceUseReportService.get(createdAt, createdAtTo, worker).pipe(first()).subscribe((res: ServiceUseReportItems) => {
            this.summary = 0;
            this.reportData = res.items;

            for (let i=0; i<this.reportData.length; i++) {
                this.summary += this.reportData[i].quantity;

                let date = new Date(this.reportData[i].createdAt);
                this.reportData[i].timezoneOffset = date.getTimezoneOffset()/60;
            }
        });
    }

    convertDateToString(date: Date): string {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    };

    today() {
        this.fastDate = 'today';
        let start = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date()),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, start);
    }

    yesterday() {
        this.fastDate = 'yesterday';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-1)));

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-1))),
            end: new FormControl(new Date(today.setDate(today.getDate()-1))),
        });

        this.updateReportData(start, start);
    }

    lastWeek() {
        this.fastDate = 'lastWeek';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-7)));
        let end = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, end);
    }

    lastMonth() {
        this.fastDate = 'lastMonth';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, end);
    }

    reloadStats(event: MatDatepickerInputEvent<any>): void {
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        try {
            start = this.dateRange.get('start').value.format('YYYY-MM-DD');
        } catch (e) {
            start = this.convertDateToString(this.dateRange.get('start').value);
        }

        try {
            end = this.dateRange.get('end').value.format('YYYY-MM-DD');
        } catch (e) {
            end = this.convertDateToString(this.dateRange.get('end').value);
        }

        this.updateReportData(start, end);
    }

    setWorker(): void {
        let data = this.dateRange.getRawValue();

        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        try {
            start = this.dateRange.get('start').value.format('YYYY-MM-DD');
        } catch (e) {
            start = this.convertDateToString(this.dateRange.get('start').value);
        }

        try {
            end = this.dateRange.get('end').value.format('YYYY-MM-DD');
        } catch (e) {
            end = this.convertDateToString(this.dateRange.get('end').value);
        }

        this.updateReportData(start, end);
    }
}
